<template>
  <div>
    <div class="row">
      <div class="col-12">
        <!-- Paginator -->
        <vue-ads-pagination
          v-if="pagination.show"
          :total-items="graphDatasetLength"
          :items-per-page="pagination.perPage"
          :page="page"
          class="ml-4 statistics-paginator d-flex flex-column align-items-start flex-md-row">
          <template slot-scope="props">
            {{$t('agenda.statistics.pagination.result', {start: props.start, end: props.end, total: props.total})}}
          </template>
          <template
            slot="buttons"
            slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              :class="{'bg-yellow-dark': button.active}"
              @page-change="page = button.page"
              @range-change="start = button.start; end = button.end"
            />
          </template>
        </vue-ads-pagination>

        <!-- Graphs -->
        <div class="center-block">
          <vertical-bar-chart
            style="height: 300px;"
            :options="barsOptions"
            :chart-data="graphData"
            @chart-init="chartInit">
          </vertical-bar-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IsMobileDevice from '@/mixins/IsMobileDeviceMixin'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination'
import VerticalBarChart from '../utils/VerticalBarChart'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
export default {
  components: {
    VueAdsPagination,
    VueAdsPageButton,
    VerticalBarChart
  },
  mixins: [
    IsMobileDevice
  ],
  props: {
    graphOptions: {
      required: true,
      type: Object
    },
    datasetKey: {
      required: true,
      type: String
    },
    dataset: {
      required: true,
      type: Array
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      self: null,
      values: {},
      labels: [],
      page: 0,
      biggerNumberInDataset: 0
    }
  },
  mounted () {
    this.graphOptions.labels.forEach(label => {
      this.$set(this.values, `${label.key}`, [])
    })
  },
  computed: {
    getYAxisIncrementor: function () {
      return this.biggerNumberInDataset < 50 ? 5 : this.biggerNumberInDataset < 100 ? 10 : this.biggerNumberInDataset < 1000 ? 100 : 1000
    },
    barsOptions: function () {
      let self = this
      return {
        scales: {
          xAxes: [{
            barPercentage: 0.9,
            categoryPercentage: 0.8,
            ticks: {
              display: !this.isMobileDevice
            },
            gridLines: {
              display: false,
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              // max: this.biggerNumberInDataset % this.getYAxisIncrementor === 0 ? this.biggerNumberInDataset + this.getYAxisIncrementor : Math.ceil(this.biggerNumberInDataset / this.getYAxisIncrementor) * this.getYAxisIncrementor + this.getYAxisIncrementor,
              suggestedMax: this.biggerNumberInDataset + this.getYAxisIncrementor
            },
            gridLines: {
              display: true
            }
          }]
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'end',
            align: 'top',
            offset: -5,
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: '#414244',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true
          },
          position: 'bottom',
          onClick: function (e, legendItem) {
            const index = legendItem.datasetIndex
            const ci = this.chart
            let meta = ci.getDatasetMeta(index)

            meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null

            if (self.graphOptions.localStorageKey) {
              let state = LocalStorageHelper.get(self.graphOptions.localStorageKey)
              let labels = state ? state.labels ? state.labels : [] : []
              if (meta.hidden) {
                labels.push(index)
              } else {
                labels = labels.filter(_index => _index !== index)
              }

              LocalStorageHelper.set(self.graphOptions.localStorageKey, {
                ...state,
                labels
              })
            }

            // Rerender the chart
            ci.update()
          }
        }
      }
    },
    graphData: function () {
      return {
        labels: this.labels,
        datasets: this.graphOptions.labels.map(label => {
          return {
            label: label.text,
            backgroundColor: label.color,
            data: this.values[label.key]
          }
        })
      }
    },
    graphDataset: function () {
      return this.dataset
    },
    graphDatasetLength: function () {
      return this.graphDataset.length
    }
  },
  methods: {
    chartInit: function ({ chart }) {
      try {
        if (this.graphOptions.localStorageKey) {
          let state = LocalStorageHelper.get(this.graphOptions.localStorageKey)
          if (state) {
            if (state.hasOwnProperty('labels') && Array.isArray(state.labels)) {
              state.labels.forEach(index => {
                let meta = chart.getDatasetMeta(index)
                meta.hidden = true
              })
            }
          }
        }
      } catch (err) {
        // Do nothing
      }
    },
    updateGraphData: function () {
      this.resetGraph()
      let countTo = (this.page + 1) * this.pagination.perPage
      for (let i = countTo - this.pagination.perPage; i < countTo; i++) {
        let item = this.graphDataset[i]
        if (item) {
          this.labels.push(item[this.datasetKey])
          this.graphOptions.labels.forEach(label => {
            let value = item[label.key]
            this.values[label.key].push(value)
            if (value > this.biggerNumberInDataset) {
              this.biggerNumberInDataset = value
            }
          })
        }
      }
    },
    resetGraph: function () {
      this.labels = []
      this.graphOptions.labels.forEach(label => {
        this.values[label.key] = []
      })
    }
  },
  watch: {
    graphDataset: {
      handler: function (graphDataset) {
        this.updateGraphData()
      },
      deep: true
    },
    graphDatasetLength: {
      handler: function () {
        this.updateGraphData()
      },
      immediate: true
    },
    page: function (page) {
      this.biggerNumberInDataset = 0
      this.updateGraphData()
    }
  }
}
</script>

<style src="vue-ads-pagination/dist/vue-ads-pagination.css"></style>
<style lang="scss">
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 40%;
  left: 50%;
}

.statistics-paginator {
  margin-left: 0 !important;
}
</style>

<style lang='scss'>
  .vuestic-chart {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      height: 100%;
      width: 100%;
    }

    canvas {
      width: 100%;
      height: auto;
    }
  }
</style>
